import { IUser } from 'src/types';
import { fetch } from '../fetchWrapper/fetch';
import { API_URL } from 'src/constants';

export interface GetUserResponse {
  data: IUser;
}

export const getUser = async (userId: string): Promise<GetUserResponse> => {
  const uri = `${API_URL}/admin/users/${userId}`;

  const response = await fetch(uri);
  if (!response.ok) {
    throw new Error('Could not fetch user');
  }
  const responseBody = await response.json();
  return responseBody;
};
